import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle, Crown, ArrowRight } from 'lucide-react';

export default function SubscriptionSuccessPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');

    return (
        <div className="min-h-screen bg-background">
            <Navbar />
            
            <div className="pt-24 pb-16 px-6 flex items-center justify-center min-h-screen">
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className="max-w-md w-full"
                >
                    <Card className="border-secondary">
                        <CardContent className="pt-8 text-center">
                            <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
                                <CheckCircle className="w-10 h-10 text-primary" />
                            </div>
                            
                            <h1 className="font-heading text-3xl font-semibold text-foreground mb-2">
                                Payment Successful!
                            </h1>
                            
                            <div className="flex items-center justify-center gap-2 mb-6">
                                <Crown className="w-5 h-5 text-secondary" />
                                <span className="text-secondary font-semibold">Ustadh Mode Activated</span>
                            </div>
                            
                            <p className="text-muted-foreground mb-8">
                                JazakAllah khair for subscribing! You now have full access to voice-enabled 
                                Quran teaching, tajweed feedback, and personalized lesson plans.
                            </p>
                            
                            <div className="space-y-3">
                                <Button 
                                    onClick={() => navigate('/ustadh')}
                                    className="w-full bg-secondary hover:bg-secondary/90 text-secondary-foreground"
                                    data-testid="goto-ustadh"
                                >
                                    Start Learning with Ustadh
                                    <ArrowRight className="w-4 h-4 ml-2" />
                                </Button>
                                <Button 
                                    variant="outline"
                                    onClick={() => navigate('/chat')}
                                    className="w-full"
                                >
                                    Go to Chat
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                </motion.div>
            </div>
        </div>
    );
}
